import { render, staticRenderFns } from "./DocumentFolderTemplate.vue?vue&type=template&id=a5aa91d6"
import script from "./DocumentFolderTemplate.vue?vue&type=script&lang=js"
export * from "./DocumentFolderTemplate.vue?vue&type=script&lang=js"
import style0 from "./DocumentFolderTemplate.vue?vue&type=style&index=0&id=a5aa91d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports